// extracted by css-extract-rspack-plugin
export default {"item":"_224e78e0","isSelected":"_7aeb0e46"};